import React, {useEffect, useState} from 'react';
import {PremiumInfo, usePulsoidClient} from '../../../../PulsoidClient';
import {Nav} from 'react-bootstrap';
import {SaleButtonClassName, SaleComponent} from '../../../../system/sale';
import {ButtonV2} from '../../../../system/ButtonV2/ButtonV2';
import {PremiumFeatureDescription} from '../../../../system/FeatureDescriptionModal';

export const BroPlanTopBarButton = (props) => {
  const client = usePulsoidClient();
  const [premiumInfo, setPremiumInfo] = useState<PremiumInfo | null>(null);

  useEffect(() => {
    client.getPremiumInfo().then((info) => {
      setPremiumInfo(info);
    });
  }, [client]);

  let component = <></>;
  if (premiumInfo && !premiumInfo.isSubscribed) {
    component = (
      <>
        <Nav.Link href="https://pulsoid.net/pricing?bi.from=navnbar">
          <ButtonV2
            onClick={() => undefined}
            type="primary-outline"
            className={SaleButtonClassName}
          >
            <SaleComponent />

            <span>Upgrade to BRO</span>
          </ButtonV2>
        </Nav.Link>
        <Nav.Item className="Nav-link">
          <PremiumFeatureDescription />
        </Nav.Item>
      </>
    );
  }

  return component;
};
